import { KlevuTypeOfRecord, KlevuTypeOfRequest } from "../../models/index.js";
const defaultOptions = {
    id: "newarrivals",
};
/**
 * Get new arrival recommendations
 *
 * @category RecommendationQuery
 * @param category
 * @param options
 * @param modifiers
 * @returns
 */
export function newArrivals(category, options, ...modifiers) {
    const params = Object.assign(Object.assign({}, defaultOptions), options);
    const settings = {
        typeOfRecords: [KlevuTypeOfRecord.Product],
    };
    if (category) {
        settings.query = {
            categoryPath: category,
        };
    }
    const query = {
        id: params.id,
        typeOfRequest: KlevuTypeOfRequest.NewArrivals,
        settings,
    };
    return {
        klevuFunctionId: "recommendation",
        modifiers,
        queries: [query],
    };
}
